import DocumentReference from "./document";

type Message = {
  id: string;
  conversationId: string;
  human: boolean;
  text: string;
  rating: MessageRating;
  //userId: string;
  references: DocumentReference[];
  language?: string;
  chainOfThought?: boolean;
  chainOfThoughtMessage?: string;
  revisedPrompt?: string;
  createdAt: string;
  updatedAt: string;
  isClosed?: boolean;
  lemmatizedText?: { word: string; lemmatizedWord: string }[];
  statusShort?: string;
  statusLong?: string;
};

export enum MessageRating {
  DownVote = "DownVote",
  NeutralVote = "NeutralVote",
  UpVote = "UpVote",
}

export type ConversationLanguage = {
  name: string;
  code: string;
};

export const ConversationLanguages: Array<ConversationLanguage> = [
  { name: "Afrikaans", code: "af" },
  { name: "Arabic", code: "ar" },
  { name: "Bulgarian", code: "bg" },
  { name: "Bengali", code: "bn" },
  { name: "Catalan", code: "ca" },
  { name: "Czech", code: "cs" },
  { name: "Welsh", code: "cy" },
  { name: "Danish", code: "da" },
  { name: "German", code: "de" },
  { name: "Greek", code: "el" },
  { name: "English", code: "en" },
  { name: "Spanish", code: "es" },
  { name: "Estonian", code: "et" },
  { name: "Persian", code: "fa" },
  { name: "Finnish", code: "fi" },
  { name: "French", code: "fr" },
  { name: "Gujarati", code: "gu" },
  { name: "Hebrew", code: "he" },
  { name: "Hindi", code: "hi" },
  { name: "Croatian", code: "hr" },
  { name: "Hungarian", code: "hu" },
  { name: "Indonesian", code: "id" },
  { name: "Italian", code: "it" },
  { name: "Japanese", code: "ja" },
  { name: "Kannada", code: "kn" },
  { name: "Korean", code: "ko" },
  { name: "Lithuanian", code: "lt" },
  { name: "Latvian", code: "lv" },
  { name: "Macedonian", code: "mk" },
  { name: "Malayalam", code: "ml" },
  { name: "Marathi", code: "mr" },
  { name: "Nepali", code: "ne" },
  { name: "Dutch", code: "nl" },
  { name: "Norwegian", code: "no" },
  { name: "Punjabi", code: "pa" },
  { name: "Polish", code: "pl" },
  { name: "Portuguese", code: "pt" },
  { name: "Romanian", code: "ro" },
  { name: "Russian", code: "ru" },
  { name: "Slovak", code: "sk" },
  { name: "Slovenian", code: "sl" },
  { name: "Somali", code: "so" },
  { name: "Albanian", code: "sq" },
  { name: "Swedish", code: "sv" },
  { name: "Swahili", code: "sw" },
  { name: "Tamil", code: "ta" },
  { name: "Telugu", code: "te" },
  { name: "Thai", code: "th" },
  { name: "Tagalog", code: "tl" },
  { name: "Turkish", code: "tr" },
  { name: "Ukrainian", code: "uk" },
  { name: "Urdu", code: "ur" },
  { name: "Vietnamese", code: "vi" },
  { name: "Chinese (Simplified)", code: "zh-cn" },
  { name: "Chinese (Traditional)", code: "zh-tw" },
];

export const TEMP_HUMAN_MESSAGE_ID = "temp_message";
export const TEMP_AI_MESSAGE_ID = "temp_ai_message";

export const TEMP_AI_MESSAGE: Message = {
  human: false,
  text: "",
  id: TEMP_AI_MESSAGE_ID,
  rating: MessageRating.NeutralVote,
  references: [],
  createdAt: "",
  updatedAt: "",
  conversationId: "",
  chainOfThought: false,
  chainOfThoughtMessage: "",
  revisedPrompt: "",
};

export const TEMP_HUMAN_MESSAGE: Message = {
  human: true,
  text: "",
  id: TEMP_HUMAN_MESSAGE_ID,
  rating: MessageRating.NeutralVote,
  references: [],
  createdAt: "",
  updatedAt: "",
  conversationId: "",
  chainOfThought: false,
  chainOfThoughtMessage: "",
  revisedPrompt: "",
};

const LARA_WELCOME_MESSAGE_DANISH_TEXT =
  "Hej, jeg er Lara. Hvordan kan jeg hjælpe dig?";
export const LARA_WELCOME_MESSAGE_SWEDISH_TEXT =
  "Hej, jag är Lara. Hur kan jag hjälpa dig?";
export const LARA_WELCOME_MESSAGE_ENGLISH_TEXT =
  "Hello, I am Lara. How can I help you?";

const LODA_WELCOME_MESSAGE_DANISH_TEXT =
  "Hej, jeg er Loda. Hvordan kan jeg hjælpe dig?";
export const LODA_WELCOME_MESSAGE_SWEDISH_TEXT =
  "Hej, jag är Loda. Hur kan jag hjälpa dig?";
export const LODA_WELCOME_MESSAGE_ENGLISH_TEXT =
  "Hello, I am Loda. How can I help you?";

export const LARA_WELCOME_MESSAGE: Message = {
  human: false,
  text: LARA_WELCOME_MESSAGE_DANISH_TEXT,
  id: "welcome_message",
  rating: MessageRating.NeutralVote,
  references: [],
  createdAt: "",
  updatedAt: "",
  conversationId: "",
  chainOfThought: false,
  chainOfThoughtMessage: "",
  revisedPrompt: "",
};

export const LODA_WELCOME_MESSAGE: Message = {
  human: false,
  text: LODA_WELCOME_MESSAGE_DANISH_TEXT,
  id: "welcome_message",
  rating: MessageRating.NeutralVote,
  references: [],
  createdAt: "",
  updatedAt: "",
  conversationId: "",
  chainOfThought: false,
  chainOfThoughtMessage: "",
  revisedPrompt: "",
};

export default Message;
